import { useEffect, useState } from "react";
import api from "@/lib/api";
import { DescrizioneVoce } from "./DescrizioneVoce";
import { MisurazioniExcel } from "./MisurazioniExcel";
import { dec, eur } from "./format";

const Info = ({ label, children, testid }) => (
  <div className="rounded-md border p-3" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
    <div className="font-mono text-sm mt-1">{children}</div>
  </div>
);

export const useExcelDettaglio = (rigaId) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/righe/${rigaId}/excel-dettaglio`).then(({ data: d }) => setData(d))
      .catch((e) => setErr(e.response?.data?.detail || "Dettaglio Excel non disponibile"));
  }, [rigaId]);
  return { data, setData, err };
};

export const ExcelVoceDettaglio = ({ det, onDescrizione }) => {
  const v = det.voce;
  return (
    <div className="space-y-4" data-testid="excel-voce-dettaglio">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
        <Info label="Tariffa" testid="excel-voce-tariffa">{v.tariffa || "—"}</Info>
        <Info label="U.M.">{v.um || "—"}</Info>
        <Info label="Quantità" testid="excel-voce-quantita">{dec(v.quantita, 2, 4)}</Info>
        <Info label="Prezzo unitario" testid="excel-voce-prezzo">{eur(v.prezzo_unitario, 4)}</Info>
        <Info label="Importo" testid="excel-voce-importo"><span className="text-amber-700">{eur(v.importo)}</span></Info>
      </div>
      <div className="text-[11px] text-slate-500">Categoria «{v.categoria}» · N.Ord {v.num_ord} · foglio «{v.foglio}», riga {v.riga_file}{v.stato_note ? ` · Stato/note: ${v.stato_note}` : ""}</div>
      <DescrizioneVoce voce={v} storico={det.storico} puoModificare={det.puo_modificare} onChange={onDescrizione} />
      <MisurazioniExcel misure={det.misure} totaleMisure={det.quantita_totale_misure} voce={v} />
    </div>
  );
};
